<template>
  <svg
    style="width: 1.35rem"
    viewBox="0 0 20 22"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.03125 4.2474H6.875C6.96094 4.2474 7.03125 4.17329 7.03125 4.0827V4.2474H12.9688V4.0827C12.9688 4.17329 13.0391 4.2474 13.125 4.2474H12.9688V5.72966H14.375V4.0827C14.375 3.35598 13.8145 2.76514 13.125 2.76514H6.875C6.18555 2.76514 5.625 3.35598 5.625 4.0827V5.72966H7.03125V4.2474ZM16.875 5.72966H3.125C2.7793 5.72966 2.5 6.02406 2.5 6.38845V7.04723C2.5 7.13781 2.57031 7.21193 2.65625 7.21193H3.83594L4.31836 17.9789C4.34961 18.6809 4.90039 19.2347 5.56641 19.2347H14.4336C15.1016 19.2347 15.6504 18.683 15.6816 17.9789L16.1641 7.21193H17.3438C17.4297 7.21193 17.5 7.13781 17.5 7.04723V6.38845C17.5 6.02406 17.2207 5.72966 16.875 5.72966ZM14.2832 17.7525H5.7168L5.24414 7.21193H14.7559L14.2832 17.7525Z"
      fill="currentColor"
    />
  </svg>
</template>
